import prjphaseActionTypes from "./prjphases.types";

export const setPrjPhases = (prjphases) => ({
  type: prjphaseActionTypes.SET_PRJPHASES,
  payload: prjphases,
});
